import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Dataset } from "../_types/dataset";
import { DatasetField } from "../_types/dataset-field";
import { ReportUserGroupPermission } from "../_types/report-user-group-permission";

@Injectable({
    providedIn: 'root',
})

export class ReportsUsersGroupsPermissionsService extends Service<ReportUserGroupPermission> {
  public override type = 'reportUserGroupPermissions';
  public override url = 'reporting/reportUserGroupPermissions'; 
  
}
